export const TENANTPLANSTATUS = {
  EXPIRED: "expired",
  TRIAL: "trial",
  PAID: "paid",
  CANCELED: "canceled",
};
